import { Resources } from 'locales/localeType';

import { useSiteConfig } from './useSiteConfig';
import { useTranslate } from './useTranslations';

export type DateFormatterOptions = {
  date: string | number | Date;
  format: string[] | undefined;
  text?: keyof Resources;
};

const weekDayNames: Array<keyof Resources> = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
];

export const useDateFormatter = ({
  date,
  format,
  text = 'emptyTranslation',
}: DateFormatterOptions) => {
  const t = useTranslate();
  const { localizeDate } = useSiteConfig();

  if (!format) return localizeDate(date);

  const givenDate = new Date(date);

  const year = givenDate.getFullYear();
  const month = givenDate.getMonth() + 1;
  const day = givenDate.getDate();
  const weekDay = givenDate.getDay();

  const replacedParts = {
    YYYY: String(year),
    TY: t('year'),
    MM: String(month).padStart(2, '0'),
    TM: t('month'),
    DD: String(day).padStart(2, '0'),
    TD: t('day'),
    TW: t(weekDayNames[weekDay]),
    TEXT: t(text),
  };

  return format.reduce(
    (result, part) => (result += replacedParts[part] ?? part),
    ''
  );
};
